import {
  addStepsIndicator,
  addTableUserSelector,
  attachTableSelectHandlers,
  selectedItems,
} from "@sourcewhale/shared/src/assets/js/src/general/elements/tables.js";
import {
  addSpinner,
  backdropAlert,
  caseInsensitiveSort,
  dateForDateTimeInputValue,
  getTimezone,
  getUser,
  localDateTimeString,
  nameAndPhoto,
  removeSpinner,
  showToast,
  uuidV4,
  wrappedGet,
  wrappedPost,
  wrapTooltip,
  yesNoConfirm,
} from "@sourcewhale/shared/src/assets/js/src/general/utils";
import { addWebsocketListener } from "@sourcewhale/shared/src/assets/js/src/general/websocket";
import { initTemplates } from "@sourcewhale/shared/src/assets/js/src/sidebar/campaigns/attachments.js";
import {
  createEditor,
  getAttachmentIdsFromDom,
} from "../general/elements/tinymce.js";

const EVENTS_DICT = {};
let queryId;
let CAMPAIGNS_DICT = {};
const NOTIFICATION_DOMAINS = new Set();

const getMissingEvents = () => {
  const table = $("#scheduleTable").DataTable();

  const emailIds = table
    .rows({ page: "current" })
    .data()
    .toArray()
    .filter((row) => !EVENTS_DICT[row.emailId])
    .map((row) => row.emailId);

  if (emailIds.length)
    $.post({
      url: "/api/schedules/get_steps",
      data: JSON.stringify({ emailIds }),
      success: (res) => {
        Object.entries(res).forEach(([emailId, events]) => {
          EVENTS_DICT[emailId] = events;
        });

        const rowIds = emailIds.map((emailId) => `#schedule-row-${emailId}`);
        table.rows(rowIds).invalidate("data");
      },
    });
};

const monthCalendar = new FullCalendar.Calendar(
  document.getElementById("monthCalendar"),
  {
    height: "auto",
    eventDurationEditable: false,
    slotDuration: "01:00:00",
    snapDuration: "00:01:00",
    dayMaxEventRows: 4,
    allDaySlot: false,
    initialView: "dayGridMonth",
    themeSystem: "bootstrap",
    eventDisplay: "list-item",
    validRange: (nowDate) => ({ start: nowDate }),
    firstDay: 1,
    editable: false,
    eventTimeFormat: {
      hour: "2-digit",
      minute: "2-digit",
      meridiem: false,
      hour12: false,
    },
    titleFormat: { year: "numeric", month: "long" },
    headerToolbar: { left: "prev", center: "title", right: "next" },
  },
);

const addToCalendar = (items) => {
  addSpinner("#calendarCardBtn");
  monthCalendar.batchRendering(() => {
    items.forEach((item) => {
      monthCalendar.addEvent({
        title: item.to,
        start: item.timestamp * 1000,
        id: item.emailId,
        allDay: false,
      });
    });
  });
  removeSpinner("#calendarCardBtn");
};

const clearCalendar = () => {
  monthCalendar.batchRendering(() => {
    monthCalendar.removeAllEvents();
  });
};

const initializeCampaignSelector = () => {
  const table = $("#scheduleTable").DataTable();

  $("#campaignSelector").change((e) => {
    if (e.target.value === "__all") {
      table.columns("campaign:name").search("").draw();
      return;
    }
    table
      .columns("campaign:name")
      .search(`^${e.target.value}$`, true, false)
      .draw();
  });
};

const refreshCampaignSelector = () => {
  const selector = $("#campaignSelector");
  let val = selector.selectpicker("val");
  selector.find("option").remove();

  if (!CAMPAIGNS_DICT[val]) val = "__all";

  const campaigns = {};
  Object.entries(CAMPAIGNS_DICT).forEach(([k, v]) => {
    campaigns[v] = k;
  });

  const opts = [
    {
      selected: true,
      value: "__all",
      "data-content":
        '<i class="fab fa-telegram-plane mr-2"></i> All Campaigns',
    },
  ];

  caseInsensitiveSort(Object.keys(campaigns)).forEach((key) => {
    opts.push({
      value: campaigns[key],
      "data-content": `<i class="fab fa-telegram-plane mr-2"></i>${key}`,
    });
  });

  opts.forEach((opt) => {
    selector.append($("<option>", opt));
  });

  selector.selectpicker("render");
  selector.selectpicker("val", val);
  selector.selectpicker("refresh");
};

const updateScheduleTable = () => {
  queryId = uuidV4();
  CAMPAIGNS_DICT = {};

  const data = {
    async: true,
    queryId,
    sessionKey: sessionStorage.getItem("sessionKey"),
  };
  if ($("#senderSelector").length) {
    data.aliases = $("#senderSelector").selectpicker("val");
  }

  const table = $("#scheduleTable").DataTable();

  table.clear();
  clearCalendar();

  $("#LoadingDiv").removeClass("invisible");

  wrappedPost({
    url: "/api/schedules/query",
    data: JSON.stringify(data),
    success: (res) => {
      const inactive = Object.values(res.usersDict)
        .filter((x) => x.status === "inactive")
        .map((x) => x.email);

      if (inactive.length) {
        const s = inactive.length === 1 ? "" : "s";
        showToast({
          title: `Users must sign in before their scheduled emails can be sent`,
          subtitle: `The following user${s} must sign in before their scheduled emails can be sent: <b>${inactive.join(
            ", ",
          )}</b>`,
          type: "warning",
          timeout: 30000,
        });
      }
    },
    error: () => {
      $("#LoadingDiv").addClass("invisible");
    },
  });
};

const selectedEmailIds = () =>
  selectedItems("scheduleTable").map((item) => item.emailId);

const onCancelClick = () => {
  const nEmails = selectedEmailIds().length;
  if (nEmails === 0) {
    backdropAlert("Please select some scheduled emails");
    return;
  }

  const s = nEmails === 1 ? "" : "s";
  const message = `Cancel ${nEmails} scheduled email${s}?`;

  yesNoConfirm(message, () => {
    wrappedPost({
      url: "/api/schedules/delete",
      data: JSON.stringify({ emailIds: selectedEmailIds() }),
      spinner: ".cancel-button",
    });
  });
};

const onDontSendBeforeClick = () => {
  const emailIds = selectedEmailIds();

  if (!emailIds.length) {
    showToast({ title: "Please select some emails", type: "warning" });
    return;
  }

  $("#nMessagesSpan").text(emailIds.length);
  $("#nMessageSSpan").text(emailIds.length === 1 ? "" : "s");

  const now = Date.now() / 1000;
  $("#scheduleModalDatetime").val(dateForDateTimeInputValue(now + 10 * 60));
  $("#scheduleModal").modal("show");

  $("#scheduleModalSaveBtn")
    .off("click")
    .click(() => {
      const payload = {
        emailIds,
        timezone: getTimezone(),
        datetime: $("#scheduleModalDatetime").val(),
      };

      const current = dateForDateTimeInputValue(Date.now() / 1000);
      if (Date.parse(current) > Date.parse(payload.datetime)) {
        showToast({
          title: "Please select a time in the future",
          type: "warning",
        });
        return;
      }

      wrappedPost({
        url: "/api/schedules/delay_messages",
        data: JSON.stringify(payload),
        success: () => {
          $("#scheduleModal").modal("hide");
          updateScheduleTable();
        },
        spinner: "#scheduleModalSaveBtn",
      });
    });
};

const onSendNowClick = () => {
  const emailIds = selectedEmailIds();

  if (!emailIds.length) {
    showToast({ title: "Please select some emails", type: "warning" });
    return;
  }

  const n = emailIds.length;
  const s = n > 1 ? "s" : "";

  const msg = `Send ${n} message${s} immediately?`;

  const callback = () => {
    showToast({ title: "Sending", type: "success", timeout: 60000 });
    wrappedPost({
      url: "/api/schedules/send_messages",
      data: JSON.stringify({ emailIds }),
      success: () => {
        const table = $("#scheduleTable").DataTable();

        const formattedSchedule = table
          .rows()
          .data()
          .toArray()
          .filter((item) => !emailIds.includes(item.emailId));

        table.clear();
        table.rows.add(formattedSchedule).draw();

        clearCalendar();
        addToCalendar(formattedSchedule);
      },
    });
  };

  yesNoConfirm(msg, callback);
};

const connectTableButtons = () => {
  $(".send-now-button, .dont-send-before-button, .cancel-button").prop(
    "disabled",
    true,
  );
  $(".send-now-button").click(onSendNowClick);
  $(".dont-send-before-button").click(onDontSendBeforeClick);
  $(".cancel-button").click(onCancelClick);
};

const displayCard = (card) => {
  $("#tableCardBtn, #calendarCardBtn").prop("disabled", false);
  $(`#${card}CardBtn`).prop("disabled", true);
  $("#tableCard, #calendarCard").hide();
  $(`#${card}Card`).show();
  $("#tableCardBtn, #calendarCardBtn").removeClass("active");
  $(`#${card}CardBtn`).addClass("active");
  $("#campaignSelector").prop("disabled", card === "calendar");
  $("#campaignSelector").selectpicker("refresh");
  if (card === "calendar") monthCalendar.render();
};

// Prevent Bootstrap dialog from blocking focusin

const { countryHoliday } = getUser();
export const initializeOutbox = () => {
  monthCalendar.render();

  addWebsocketListener((data) => {
    if (data.kind === "outboxItems" && data.queryId === queryId) {
      data.items.forEach((x) => {
        CAMPAIGNS_DICT[x.campaignId] = x.campaignName;
        x.sender = data.sender;
      });

      $("#LoadingDiv").addClass("invisible");

      const table = $("#scheduleTable").DataTable();
      table.rows.add(data.items).draw(false);

      addToCalendar(data.items);

      refreshCampaignSelector();

      if (data.limitedDomains.length) {
        const mapping = {
          candidateSourcing: "Candidate Sourcing",
          businessDevelopment: "Business Development",
        };
        data.limitedDomains
          .map(
            getUser().hideCampaignTypes
              ? (x) => x.domain
              : (x) => `${x.domain} (${mapping[x.campaignType]})`,
          )
          .forEach((x) => NOTIFICATION_DOMAINS.add(x));

        const notificationDomains = Array.from(NOTIFICATION_DOMAINS)
          .sort()
          .join(", ");

        const title = "Your team has reached its Domain Send Limit";
        const subtitle = `Outreach to contacts in the following domains will be rescheduled for a future date: <b>${notificationDomains}</b><br/>Speak to your Team Admin to change the Domain Send Limit.`;

        showToast({ title, subtitle, type: "danger" });
      }

      const { sent, total } = data;
      if (data.finished && sent < total) {
        const title = "Outbox loading timed out";
        const subtitle = `Currently showing ${sent} of ${total} emails. Additional emails are not displayed in this view.`;
        showToast({ title, subtitle, type: "danger", timeout: 1e20 });
      }
    }
  });

  addTableUserSelector("scheduleTable", "sender", "Sender", {
    includeAll: false,
    useEmails: true,
    callback: () =>
      $(".sender-selector .selectpicker").on("change", updateScheduleTable),
    selectSelf: true,
  });

  $("#scheduleTable")
    .DataTable({
      buttons: {
        dom: {
          button: {
            tag: "button",
            className: "btn btn-light ml-2",
          },
        },
        buttons: [
          {
            className: "send-now-button",
            text: '<i class="fa-regular fa-share pr-1"></i> Send now',
          },
          {
            className: "dont-send-before-button",
            text: '<i class="fa-regular fa-clock pr-1"></i> Don\'t send before',
          },
          {
            className: "cancel-button",
            text: '<i class="fa-regular fa-times-circle pr-1"></i> Cancel',
          },
        ],
      },
      columns: [
        {
          data: "emailId",
          orderable: false,
          className: "select-checkbox",
          title: '<input type="checkbox" class="dt-select-all-checkbox" />',
          render: () => "",
        },
        {
          data: (x) => x,
          orderable: true,
          title: "Contact",
          render: (mail, type) => {
            const candidate = mail.candidateDetails;
            if (type === "display" || type === "filter") {
              const namePhoto = nameAndPhoto(candidate.name, candidate.photo);
              return `${namePhoto}<p class="my-0" style="font-weight: 300">${mail.to}</p>`;
            }
            return candidate.name || "";
          },
        },
        {
          data: (x) => x,
          orderable: true,
          className: "schedule-time",
          title: `
              Scheduled Time
              <i
                class="fas fa-info-circle ml-2"
                data-toggle="tooltip"
                data-bss-tooltip=""
                title="Times are subject to change, as you add more messages and receive replies."
              ></i>`,
          render: (mail, type) => {
            if (type === "display" || type === "filter") {
              let ret = localDateTimeString(mail.timestamp);
              if (mail.notBefore && mail.notBefore > Date.now() / 1000) {
                const notBefore = localDateTimeString(mail.notBefore);
                ret = `${ret} <i class="ml-2 far fa-circle-info dont-send-before-info" title="This step was set not to send before ${notBefore}" data-toggle="tooltip"></i>`;
              }
              if (getTimezone() !== mail.timezone) {
                const localTime = localDateTimeString(
                  mail.timestamp,
                  true,
                  mail.timezone,
                );
                ret = `${ret}<br><small>Local time: ${localTime}</small>`;
              }
              return ret;
            }
            return mail.timestamp;
          },
        },
        {
          data: (x) => x,
          orderable: true,
          title: "Campaign",
          render: (mail, type) =>
            type === "display"
              ? `<a href="/campaign?campaignId=${mail.campaignId}" target="_blank">${mail.campaignName}</a>`
              : mail.campaignName,
        },
        {
          data: (x) => x,
          title: "Step",
          orderable: true,
          render: (x, type) =>
            addStepsIndicator(EVENTS_DICT[x.emailId], type, x.step, x.nSteps),
        },
        {
          data: (x) => x,
          render: (mail) =>
            wrapTooltip(
              `<i
                class="far fa-edit view-button"
                data-name="${mail.candidateDetails.name}"
                data-emailId="${mail.emailId}"
                style="cursor: pointer; caret-color: transparent;">
              </i>`,
              "Edit Content",
            ),
        },
        { data: "campaignId", name: "campaign", visible: false },
      ],
      columnDefs: [{ targets: "_all", orderable: false }],
      deferRender: true,
      dom: `
          <'row mb-3'
            <'col-12 text-center table-buttons d-flex align-items-center'fB>
          >
          <'row'
            <'col-12't>
          >
          <'row mx-2 my-5 d-flex align-items-center'
            <'col-4'i>
            <'col-4 text-center'l>
            <'col-4'p>
          >`,
      fixedHeader: true,
      fnInfoCallback: (_, iStart, iEnd, __, iTotal) =>
        `${iStart}-${iEnd} of <b>${iTotal}</b>`,
      preDrawCallback: () => {
        $('[data-toggle="tooltip"]').tooltip("dispose");
      },
      drawCallback: () => {
        $('[data-toggle="tooltip"]').tooltip("dispose").tooltip({
          placement: "bottom",
          html: true,
        });

        getMissingEvents();
      },
      language: {
        search:
          '<i class="fa-regular fa-magnifying-glass" aria-hidden="true"></i>',
        searchPlaceholder: "Search by name, email or campaign",
        emptyTable: "No matching scheduled messages",
        infoEmpty: "No matching scheduled messages",
        zeroRecords: "No matching scheduled messages",
        processing: '<i class="spinner-grow text-primary"></i>',
      },
      order: [[3, "asc"]],
      pageLength:
        parseInt(localStorage.getItem("scheduleTablePageLength"), 10) || 25,
      rowId: (x) => `schedule-row-${x.emailId}`,
      select: { style: "multi+shift", selector: "td:first-child" },
    })
    .on("length.dt", (_, __, len) => {
      localStorage.setItem("scheduleTablePageLength", len);
    });

  $(document).on("click", ".view-button", (e) => {
    $(e.target).removeClass("fa-edit").addClass("fa-circle-notch fast-spin");
    const emailId = $(e.target).attr("data-emailId");
    const editor = tinymce.get("messageTextEditor");

    wrappedGet({
      url: "/api/schedules/get_message",
      data: { emailId },
      success: (res) => {
        initTemplates({
          type: "single",
          key: "messageTextEditor",
          attachmentIds: res.attachmentIds,
        });

        $(e.target)
          .addClass("fa-edit")
          .removeClass("fa-circle-notch fast-spin");

        editor.setContent(res.messageText);
        $("#subjectEditor").val(
          res.sendAsReply ? "Re: <previous subject line>" : res.subject,
        );
        $("#subjectEditor").prop("disabled", res.sendAsReply === true);
        $("#messageModalName").text($(e.target).attr("data-name"));
        $("#messageModal").modal("show");

        $("#messageTextSaveBtn")
          .off("click")
          .on("click", () => {
            wrappedPost({
              url: "/api/schedules/save_message",
              data: JSON.stringify({
                emailId,
                content: editor.getContent(),
                subject: res.sendAsReply
                  ? res.subject
                  : $("#subjectEditor").val(),
                attachmentIds: getAttachmentIdsFromDom(),
              }),
              success: () => {
                showToast({ title: "Saved", type: "success" });
                $("#messageModal").modal("hide");
                updateScheduleTable();
              },
              spinner: "#messageTextSaveBtn",
            });
          });
      },
      error: () => {
        $(e.target)
          .addClass("fa-edit")
          .removeClass("fa-circle-notch fast-spin");
      },
    });
  });

  connectTableButtons();

  initializeCampaignSelector();

  addWebsocketListener(() => {
    updateScheduleTable();
  }, "open");

  attachTableSelectHandlers("scheduleTable", true, () => {
    $(".send-now-button, .dont-send-before-button, .cancel-button").prop(
      "disabled",
      !selectedEmailIds().length,
    );
  });

  ["table", "calendar"].forEach((card) => {
    $(`#${card}CardBtn`).click(() => {
      displayCard(card);
    });
  });

  createEditor({ selector: "#messageTextEditor", content: "" });

  $("#messageModal").on("hidden.bs.modal", () => {
    $(".tox-toolbar__overflow").hide();
  });

  $(document).on("focusin", (e) => {
    if (
      e.target.closest(
        ".tox-tinymce-aux, .moxman-window, .tam-assetmanager-root",
      ) !== null
    ) {
      e.stopImmediatePropagation();
    }
  });

  addWebsocketListener((message) => {
    if (message.kind === "update-send-mail") {
      let changed = false;

      const table = $("#scheduleTable").DataTable();

      message.changes.forEach((change) => {
        const { update } = change;
        const { ids } = change;

        if (update.status && update.status !== "active") {
          table.rows().every((index) => {
            const row = table.row(index);
            if (ids.includes(row?.data()?.emailId)) {
              table.row(row.node()).remove().draw();
              changed = true;
            }
            return true;
          });
        }
      });
      if (changed) table.rows().invalidate();
    }
  });

  if (countryHoliday) {
    const country = countryHoliday.startsWith("United")
      ? `the ${countryHoliday}`
      : countryHoliday;
    showToast({
      title: `Today is a public holiday in ${country}`,
      subtitle:
        'You can change your holiday settings <a href="/profile" target="_blank">here</a>',
      timeout: 3600000,
    });
  }
};
